module.exports = __webpack_public_path__ + "img/arrow-bottom.7b7ebb51.svg";